import {
  Dialog,
  DialogContent,
  DialogHeader,
  Radio,
  RadioGroup,
} from "@stacklet/ui";

interface Props {
  openDialog(arg: boolean): void;
  isDialogOpen: boolean;
  onViewChanged(arg: string): void;
  children: React.ReactNode;
  selectedValue: string;
  radioOptions: { title: string; value: string }[];
  type: string;
}

export function DialogWithRadioOptions({
  children,
  openDialog,
  isDialogOpen,
  radioOptions,
  onViewChanged,
  selectedValue,
  type,
}: Props) {
  const selectedTitle =
    radioOptions.find((option) => option.value === selectedValue)?.title ?? "";

  return (
    <Dialog
      data-testid={`form-dialog-${type}-${selectedValue}`}
      isOpen={isDialogOpen}
      onOpenChange={(open) => !open && openDialog(false)}
      size="xl"
      isDismissable
    >
      <DialogHeader>{selectedTitle}</DialogHeader>
      <DialogContent>
        <RadioGroup
          aria-label="view-dialog"
          className="pb-lg"
          name="viewDialog"
          onChange={onViewChanged}
          orientation="horizontal"
          value={selectedValue}
        >
          {radioOptions.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.title}
            </Radio>
          ))}
        </RadioGroup>
        {children}
      </DialogContent>
    </Dialog>
  );
}
